import { PageMode } from "@features/scenarioDesign/ScenarioDesignPage"
import { Button, Grid, Typography } from "@mui/material"
import ViewListIcon from "@mui/icons-material/ViewList"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"

type StartModeButtonsProps = {
  onChangeMode: (newMode: PageMode) => void
}

const StartModeButtons = ({ onChangeMode }: StartModeButtonsProps) => {
  return (
    <>
      <Grid item>
        <Button
          startIcon={<AddCircleOutlineIcon />}
          variant="contained"
          sx={{ background: "black" }}
          onClick={() => onChangeMode(PageMode.CreateScenario)}
        >
          <Typography className={"hideNarrow1230"}>Create new scenario</Typography>
        </Button>
      </Grid>
      <Grid item>
        <Button
          startIcon={<ViewListIcon />}
          variant="contained"
          sx={{ background: "black" }}
          onClick={() => onChangeMode(PageMode.ViewRuns)}
        >
          <Typography className={"hideNarrow1230"}>View runs</Typography>
        </Button>
      </Grid>
    </>
  )
}

export default StartModeButtons
